export default "__VITE_ASSET__583390bf__"